import React, { useState, useEffect } from "react";
import background from "./images/background.png";

const AddPhrase = () => {
  const [phrase, setPhrase] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const placeholders = [
    "¿Se nos escapó una icónica? Mándala 😘",
    "Esa frase legendaria merece estar aquí 🔥",
    "Tú sabes cuál falta... suéltala 💅",
    "Completa el vibe, no te la guardes ✨",
    "Una joyita más pa' la colección 💖",
    "Momento Karime que hay que guardar 💋",
    "¿Otra joyita del chisme? Échala 👀",
    "Tírame la bomba que falta 💣💋",
    "Solo los OGs recuerdan esta frase 👑",
    "¿Eres fan de verdad? Suelta esa joya 🫢",
    "La frase que gritas con tus amigas va aquí 🫶",
    "Esta app también vibra contigo, mándala ✍️",
    "¡Entre fans se arma mejor el desmadre! 🥳",
  ];
  const randomPlaceholder =
    placeholders[Math.floor(Math.random() * placeholders.length)];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phrase.trim()) {
      setError("Escribe una frase primero 💬");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const response = await fetch("/api/submit-phrase", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phrase }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Algo salió mal.");
      setSubmitted(true);
      setPhrase("");
    } catch (err) {
      setError(err.message || "Error inesperado.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      const timeout = setTimeout(() => setError(""), 7000);
      return () => clearTimeout(timeout);
    }
  }, [error]);

  return (
    <div
      className="min-h-full px-6 py-16 font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="max-w-xl mx-auto text-center px-5 py-6"
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "20px",
          border: "2px solid #f9a8d4",
          boxShadow: "0 8px 32px rgba(176,106,179,0.12)",
        }}
      >
        <h1 className="text-xl font-bold mb-3" style={{ color: "#b06ab3" }}>
          ✨ ¿Falta una frase icónica?
        </h1>

        <p className="text-sm mb-5" style={{ color: "#6b7280" }}>
          Si crees que falta alguna joyita de frase, mándamela aquí abajo 🩵
        </p>

        {submitted ? (
          <div className="font-medium text-sm" style={{ color: "#b06ab3" }}>
            ¡Gracias, bb! Tu frase fue enviada 💖
            <br />
            Si está perrísima, la verás pronto en la app 😘
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <textarea
              value={phrase}
              onChange={(e) => setPhrase(e.target.value)}
              placeholder={randomPlaceholder}
              className="w-full p-4 rounded-2xl shadow-sm focus:outline-none focus:ring-2"
              style={{
                border: "1.5px solid #c4b5fd",
                color: "#2d1f3d",
                fontSize: "14px",
              }}
              rows={4}
            />

            {error && (
              <p className="text-sm" style={{ color: "#f472b6" }}>
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="bg-custom-blue text-white px-6 py-3 rounded-full font-semibold disabled:opacity-50 active:scale-95 transition-transform"
              style={{ boxShadow: "0 4px 12px rgba(125,211,252,0.4)" }}
            >
              {loading ? "Enviando..." : "Enviar frase"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AddPhrase;
